import { render, staticRenderFns } from "./SwapTaskModal.vue?vue&type=template&id=2046f4a6&scoped=true"
import script from "./SwapTaskModal.vue?vue&type=script&lang=js"
export * from "./SwapTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2046f4a6",
  null
  
)

export default component.exports